import toast from "react-hot-toast";

export const copyToClipboard = async (
  value,
  message = "Copied to clipboard",
) => {
  try {
    await navigator.clipboard.writeText(value);
    toast.success(message);
    return true;
  } catch (error) {
    console.error("Copy failed:", error);
    toast.error("Failed to copy");
    return false;
  }
};
